import React from "react";

const StudentAchievementStrip = ({ data }) => (

    <section className="student-achievement-strip">
{console.log("ACHI:::",data)}
        <div className="container">

            <div className="achievement-strip-grid">

                {(data.items || []).map((item, i) => (

                    <div
                        className="achievement-strip-item"
                        key={i}
                    >

                        <strong>
                            {item.value}
                        </strong>

                        <span>
                            {item.title}

                            <small>
                                {item.subtitle}
                            </small>
                        </span>

                    </div>

                ))}

            </div>

        </div>

    </section>
);

export default StudentAchievementStrip;